import { SORT_KEY } from "../../../const/SORT_KEY.ts";
import { useSearchParamsHandler } from "../../../hooks/useSearchParamsHandler.ts";

const SortSelect = () => {
  const { set } = useSearchParamsHandler("sort");

  return (
    <select
      className="select w-full"
      onChange={(e) => {
        set(e.target.value);
      }}
    >
      <option value={SORT_KEY.UPDATED}>Veröffentlichung</option>
      <option value={SORT_KEY.PRICE}>Preis</option>
    </select>
  );
};
export default SortSelect;
